import { render, staticRenderFns } from "./newcontribute.vue?vue&type=template&id=0d0e3aba&scoped=true"
import script from "./newcontribute.vue?vue&type=script&lang=js"
export * from "./newcontribute.vue?vue&type=script&lang=js"
import style0 from "./newcontribute.vue?vue&type=style&index=0&id=0d0e3aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e3aba",
  null
  
)

export default component.exports